import styled from 'styled-components';

export const TabPanel = styled.div`
  padding-top: 1vh;
  height: 86.9vh;
  align-content: center;
`;
